import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.90922 0.000179007C1.7464 0.000179007 1.58339 0.0622029 1.4593 0.186609L0.186609 1.4593C-0.062203 1.70812 -0.062203 2.11096 0.186609 2.35914L4.82747 7L0.186609 11.6409C-0.062203 11.8897 -0.062203 12.2925 0.186609 12.5407L1.4593 13.8134C1.70812 14.0622 2.11096 14.0622 2.35914 13.8134L7 9.17253L11.6409 13.8134C11.889 14.0622 12.2925 14.0622 12.5407 13.8134L13.8134 12.5407C14.0622 12.2919 14.0622 11.889 13.8134 11.6409L9.17253 7L13.8134 2.35914C14.0622 2.11096 14.0622 1.70748 13.8134 1.4593L12.5407 0.186609C12.2919 -0.062203 11.889 -0.062203 11.6409 0.186609L7 4.82747L2.35914 0.186609C2.23473 0.0622029 2.07205 0.000179007 1.90922 0.000179007Z",
    fill: "black"
  })
], -1 /* HOISTED */)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "abs-position close-btn",
    onClick: $setup.emitCloseClicked
  }, _hoisted_2))
}